"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` Workflow Drafts Service
 */
var WorkflowDrafts = /*#__PURE__*/function (_Base) {
  /**
   * Create workflow draft service instance
   *
   * @param sdk - the SDK instance
   */
  function WorkflowDrafts(sdk) {
    (0, _classCallCheck2["default"])(this, WorkflowDrafts);
    return _callSuper(this, WorkflowDrafts, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(WorkflowDrafts, _Base);
  return (0, _createClass2["default"])(WorkflowDrafts, [{
    key: "createWorkflowDraft",
    value: (
    /**
     * Create workflow draft.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1workflow-drafts/post
     *
     * @param projectId - , is the project id
     * @param payload -, is the workflow draft body
     *     name,
     *     templateId,
     *     steps,
     *     description,
     *     approvalOptions,
     *     rules,
     *     descriptiveLanguage
     * @param config -  Configurable object for overwrite request parameters.
     * @returns workflow draft.
     */
    function () {
      var _createWorkflowDraft = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/workflow-drafts");
              _context.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createWorkflowDraft(_x, _x2, _x3) {
        return _createWorkflowDraft.apply(this, arguments);
      }
      return createWorkflowDraft;
    }()
    /**
     * Update workflow draft.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1workflow-drafts~1%7Bdraft_workflow_id%7D/patch
     *
     * @param projectId - , is the project id
     * @param workflowDraftId -, is the workflow draft id
     * @param payload -, is the workflow draft body
     *     id,
     *     name,
     *     templateId,
     *     steps,
     *     description,
     *     approvalOptions,
     *     rules,
     *     descriptiveLanguage
     * @param config -  Configurable object for overwrite request parameters.
     * @returns workflow draft.
     */
    )
  }, {
    key: "updateWorkflowDraft",
    value: (function () {
      var _updateWorkflowDraft = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, workflowDraftId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/workflow-drafts/").concat(workflowDraftId);
              _context2.next = 3;
              return this.HttpService.dmV3.patch(url, payload, config);
            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateWorkflowDraft(_x4, _x5, _x6, _x7) {
        return _updateWorkflowDraft.apply(this, arguments);
      }
      return updateWorkflowDraft;
    }()
    /**
     * Get workflow drafts with pagination.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1workflow-drafts/get
     *
     * @param projectId - , is the project id
     * @param params - with the shape of `offset`, `limit`, `sort`, `folderDetails`
     * @param config -  Configurable object for overwrite request parameters..
     * @returns results and pagination
     */
    )
  }, {
    key: "getWorkflowDrafts",
    value: (function () {
      var _getWorkflowDrafts = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/workflow-drafts").concat(query);
              _context3.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getWorkflowDrafts(_x8, _x9, _x10) {
        return _getWorkflowDrafts.apply(this, arguments);
      }
      return getWorkflowDrafts;
    }()
    /**
     * Delete workflow draft with id.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1workflow-drafts~1%7Bdraft_workflow_id%7D/delete
     *
     * @param projectId - , is the project id
     * @param workflowDraftId -, is the workflow draft id
     * @param config -  Configurable object for overwrite request parameters..
     * @returns empty data with status 204
     */
    )
  }, {
    key: "deleteWorkflowDraft",
    value: (function () {
      var _deleteWorkflowDraft = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, workflowDraftId, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/projects/".concat(projectId, "/workflow-drafts/").concat(workflowDraftId);
              _context4.next = 3;
              return this.HttpService.dmV3["delete"](url, config);
            case 3:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteWorkflowDraft(_x11, _x12, _x13) {
        return _deleteWorkflowDraft.apply(this, arguments);
      }
      return deleteWorkflowDraft;
    }()
    /**
     * Get workflow draft by id.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1workflow-drafts~1%7Bdraft_workflow_id%7D/get
     *
     * @param projectId - , is the project id
     * @param workflowDraftId -, is the workflow draft id
     * @param params - is the query parameter, such as `folderDetails`
     * @param config -  Configurable object for overwrite request parameters.
     * @returns workflow draft.
     */
    )
  }, {
    key: "getWorkflowDraft",
    value: (function () {
      var _getWorkflowDraft = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, workflowDraftId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/workflow-drafts/").concat(workflowDraftId).concat(query);
              _context5.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context5.sent;
              return _context5.abrupt("return", res.data || {});
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getWorkflowDraft(_x14, _x15, _x16, _x17) {
        return _getWorkflowDraft.apply(this, arguments);
      }
      return getWorkflowDraft;
    }()
    /**
     * Publish workflow drafts to workflows
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7Dworkflow-drafts:batch-publish/post
     *
     * @param projectId - , is the project id
     * @param payload -, is the array of workflow draft
     * @param config -  Configurable object for overwrite request parameters.
     * @returns results and errors
     */
    )
  }, {
    key: "publishWorkflowDrafts",
    value: (function () {
      var _publishWorkflowDrafts = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/projects/".concat(projectId, "/workflow-drafts:batch-publish");
              _context6.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function publishWorkflowDrafts(_x18, _x19, _x20) {
        return _publishWorkflowDrafts.apply(this, arguments);
      }
      return publishWorkflowDrafts;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'WorkflowDrafts';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = WorkflowDrafts;